import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export interface IPOSProps {
  user_id: string;
  clinic_id: string;
  amount: number;
  payment_mode: string;
  invoice_ids: Array<string>;
}
export const useOnlinePaymentValidateAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (order_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.ONLINE_PAYMENT_API?.baseURL}${order_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              return { status: true, message: res.data?.data?.order_status};
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message:null };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
